import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'rc-scroll-anim';
import download from '../assets/imgs/download.gif';
import title from '../assets/imgs/title.png';

class Banner extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    isMobile: PropTypes.bool,
    navToShadow: PropTypes.func,
  }
  static defaultProps = {
    className: 'banner',
  }
  constructor(props) {
    super(props)
    this.state = {
      appUrl: '',
    }
  }
  componentDidMount(){
    console.log(window.location.origin)
    fetch( window.location.origin + '/downloadApp',{
      method:'GET',
      headers:{'Content-Type':'application/json;charset=UTF-8'},
      mode:'no-cors',
      cache:'default'
    })
    .then(res =>res.json())
    .then((res) => {
      if(res.ret === 0) {
        const { data={} } = res;
        this.setState({
          appUrl: data.url,
        })
      }
    }) 
  }

  render() {
    const { className, navToShadow, isMobile } = this.props;
    return (
      <Element id="home" component="section" className={(isMobile ? 'block-mobile ': '')}  onChange={navToShadow}>
        <div className={className + (isMobile ? '-mobile ': '')}>
          <div className={`bgWrapper`}>
              <div className={`content`}>
                {/* <div className={`title`}>{'¡Le Ayudamos A Obtener Un Préstamo Más Fácilmente!'}</div> */}
                <img className={`title`} src={title} alt='title'/>
                <div className={`subtitle`}>{'Max amount up to ₱20000'}</div>
                <div className={`desc`}>{'Loan released in 2 hours to 24 hours'}</div>
                {/* <a target="_blank" rel="noopener noreferrer" href={andro} key="a" className={`word-download`}>
                  <button className="banner-btn"><a    target="_blank" href={appUrl} key="a" rel="noopener noreferrer"><img className="banner-img" src={download} alt='downLoad'/>Descargar CashInca </a></button>
                </a> */}
                <img src={download} onClick={() => {window.location.href=this.state.appUrl}} className="banner-btn" alt='download'/>
             
              </div>
              
          </div>
        </div>
      </Element>
    );
  }
}

export default Banner;
